module.exports = __webpack_public_path__ + "static/media/manufacturing-macrovector-02-c 1.6cc6b435.png";